import { memo, useCallback, useEffect, useRef } from 'react';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlass';
import { SearchForm } from '@layouts/toolbar/search/SearchForm';



interface SearchProps {
	isSmallScreen: boolean,
	searchIsOpen: boolean,
	setSearchIsOpen: (searchIsOpen: boolean) => void,
}


const Search = (props: SearchProps) => {
	const { isSmallScreen, searchIsOpen, setSearchIsOpen } = props;

	const hasPermission = useHasPermission();
	const inputRootRef = useRef<HTMLFormElement>(null);


	useEffect(() => {
		document.addEventListener('mousedown', clickOutsideListener);
		return () => {
			document.removeEventListener('mousedown', clickOutsideListener);
		};
	}, []);


	const clickOutsideListener = useCallback((event: MouseEvent) => {
		if (event.target && inputRootRef && inputRootRef.current && !inputRootRef.current.contains(event.target as Element)) {
			setSearchIsOpen(false);
		}
	}, [ inputRootRef ]);


	if (!hasPermission(AppRolesEnum.orders_Read)) return (
		<div className='toolbar-search'>
		</div>
	)

	return (
		<div className={`toolbar-search${searchIsOpen && isSmallScreen ? ' small-search-open' : ''}`}>
			
			<FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} onClick={() => isSmallScreen ? setSearchIsOpen(!searchIsOpen) : {}} />

			<div className={`horizontal-collapsible-element${searchIsOpen ? ' is-open' : ''}`}>
				<SearchForm ref={inputRootRef} />
			</div>

		</div>
	);
}

export default memo(Search);